import React from 'react';

/**
 * Tab navigation component for settings sidebar
 * Renders clickable tab buttons with icons and active state styling
 */
const TabNavigation = ({ tabs, activeTab, onTabChange }) => {
  return (
    <div className="lg:w-64">
      <nav className="space-y-1">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors duration-200 ${
                activeTab === tab.id
                  ? 'bg-pest-blue text-white'
                  : 'text-gray-700 hover:bg-gray-100'
              }`}
            >
              <Icon size={20} />
              <span className="font-medium">{tab.label}</span>
            </button>
          );
        })}
      </nav>
    </div>
  );
};

export default TabNavigation;